import React from "react";

interface NotificationIconProps {
  color?: string;
  className?: string;
}

export const NotificationIcon: React.FC<NotificationIconProps> = ({
  color,
  className,
}) => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.375 13.7371C1.19792 13.7371 1.04948 13.6772 0.929688 13.5574C0.809896 13.4375 0.75 13.289 0.75 13.1119C0.75 12.9347 0.809896 12.7863 0.929688 12.6666C1.04948 12.547 1.19792 12.4872 1.375 12.4872H2.25642V6.26919C2.25642 5.14847 2.6023 4.15755 3.29406 3.29644C3.98584 2.43533 4.87393 1.88458 5.95833 1.64421V1.12498C5.95833 0.835633 6.05951 0.589689 6.26188 0.387147C6.46424 0.184592 6.70996 0.083313 6.99904 0.083313C7.28813 0.083313 7.53416 0.184592 7.73715 0.387147C7.94013 0.589689 8.04163 0.835633 8.04163 1.12498V1.64421C9.12603 1.88458 10.0141 2.43533 10.7059 3.29644C11.3977 4.15755 11.7435 5.14847 11.7435 6.26919V12.4872H12.625C12.802 12.4872 12.9505 12.5471 13.0703 12.6669C13.1901 12.7868 13.25 12.9353 13.25 13.1124C13.25 13.2896 13.1901 13.438 13.0703 13.5576C12.9505 13.6773 12.802 13.7371 12.625 13.7371H1.375ZM6.99856 16.0769C6.58391 16.0769 6.22942 15.9294 5.93508 15.6344C5.64075 15.3394 5.49358 14.9847 5.49358 14.5705H8.50638C8.50638 14.9861 8.35874 15.341 8.06346 15.6354C7.76818 15.9297 7.41322 16.0769 6.99856 16.0769ZM3.50638 12.4872H10.4936V6.26919C10.4936 5.30444 10.1525 4.48099 9.47033 3.79883C8.78818 3.11667 7.96473 2.77558 6.99998 2.77558C6.03523 2.77558 5.21178 3.11667 4.52963 3.79883C3.84746 4.48099 3.50638 5.30444 3.50638 6.26919V12.4872Z"
        fill={color ?? "currentColor"}
      />
    </svg>
  );
};
